<div class="center">
  <mat-card id="style-4" class="cardcomponentMasks" style="overflow: hidden" *ngIf="!this.isConfigurationActive">
    <mat-card-content class="messages" style="text-align: left; color: black; border-bottom: inset; margin-bottom: 0px">
      <button mat-icon-button (click)="this.isConfigurationActive = !this.isConfigurationActive" style="float: right"
              *ngIf="this.apiService.userInfo.description == 'Admin'">
        <mat-icon>settings</mat-icon>
      </button>
      <div *ngFor="let message of messages" class="message"
           [ngClass]="{'user': message.sender === 'user', 'bot': message.sender === 'bot'}">
        <b style = "color: {{this.apiService.dashColor}}">
          <ng-container *ngIf="message.sender == 'bot'">Assistente</ng-container>
          <ng-container *ngIf="message.sender == 'user'">{{ this.apiService.userInfo.description }}</ng-container>
          :
        </b>
        <div [innerHTML]="message.content"></div>
        <hr style="color: {{this.apiService.dashColor}}; width: 90%">
      </div>
      <mat-spinner *ngIf="isLoading" diameter="30"></mat-spinner>
    </mat-card-content>
    <mat-card-actions style="text-align: center; flex-direction: column;">

      <div style="display: inline-flex; width: 60%; align-items: center;">





        <ng-container *ngIf="uploadedFiles.length > 0">
          <button mat-icon-button [disabled]="isLoading" [matMenuTriggerFor]="aboveMenu" matBadge="{{uploadedFiles.length}}" matBadgePosition="before" style="color: {{this.apiService.dashColor}}">
            <mat-icon>attach_file</mat-icon>
          </button>
          <mat-menu #aboveMenu="matMenu" yPosition="above" xPosition="before">
            <div *ngFor="let file of uploadedFiles; let i = index" class="menu-item">
              <mat-icon class="file-icon">description</mat-icon>
              <span class="file-name">{{ file.name }}</span>
              <button mat-icon-button color="warn" (click)="removeFile(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-menu>
        </ng-container>
        <button mat-icon-button (click)="fileInput.click()" [disabled]="isLoading" style="color: {{this.apiService.dashColor}}">
          <mat-icon>cloud_upload</mat-icon>
        </button>
        <input type="file" #fileInput multiple style="display: none" (change)="handleFileInput($event)">



        <mat-form-field class="message-input" style="flex-grow: 1; margin-right: 10px;">
          <textarea matInput [(ngModel)]="userInput" [disabled]="isLoading" (keyup.enter)="sendMessage()" style="resize: none;" rows = "2"
                    placeholder="Scrivi il tuo messaggio..."></textarea>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="sendMessage()" [disabled]="isLoading">Invia</button>
      </div>
    </mat-card-actions>
  </mat-card>


  <mat-card id="style-4" class="cardcomponentMasks" style="overflow: hidden" *ngIf="this.isConfigurationActive">

    <mat-card-content style="text-align: left; color: black; border-bottom: inset;">
      <button mat-icon-button (click)="this.isConfigurationActive = !this.isConfigurationActive" style="float: right">
        <mat-icon>chat</mat-icon>
      </button>

      <!-- Configuration Content -->
      <h2>Configurazione assistente</h2>
      <form>
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Client ID</mat-label>
          <input matInput placeholder="Enter value" [(ngModel)]="this.assistantConfiguration['client_id']" ngModel
                 [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Client secret</mat-label>
          <input matInput placeholder="Enter value" [(ngModel)]="this.assistantConfiguration['client_secret']" ngModel
                 [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Open AI api KEY</mat-label>
          <input matInput placeholder="Enter value" [(ngModel)]="this.assistantConfiguration['openai_api_key']" ngModel
                 [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Ragione sociale</mat-label>
          <input matInput placeholder="Enter value" [(ngModel)]="this.assistantConfiguration['ragione_sociale']" ngModel
                 [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <br>
        <!--<ng-container *ngFor = "let documento of this.assistantConfiguration.url_documentazione">
          <br>
          <mat-form-field appearance="outline" class = "form-field" >
            <mat-label>Url file</mat-label>
            <input matInput placeholder="Enter value" ngModel [ngModelOptions]="{standalone: true}" [(ngModel)] = "documento['url']">
          </mat-form-field>
          <mat-form-field appearance="outline" class = "form-field" >
            <mat-label>Nome file</mat-label>
            <input matInput placeholder="Enter value" ngModel [ngModelOptions]="{standalone: true}" [(ngModel)] = "documento['nomeFile']">
          </mat-form-field>
        </ng-container>-->
        <div class="file-upload-wrapper">
          <input [type]="fileInputType" (change)="onFileSelected($event)" #fileInput hidden>
          <button mat-raised-button (click)="fileInput.click()">
            <mat-icon>folder_open</mat-icon>
            Carica File
          </button>
        </div>

        <mat-divider></mat-divider>

        <mat-list>
          <ng-container *ngFor="let documento of this.assistantConfiguration.url_documentazione">
            <div style = "display: flex">
              <mat-list-item lines="2" style = "width: 60%; margin: auto;" >
                <mat-icon matListItemIcon>insert_drive_file</mat-icon>
                <h3 matListItemTitle>{{ documento.nomeFile }}</h3>
                <p matListItemLine>File</p>

              </mat-list-item>
              <div style = "width: 40%; margin: auto;">
                <button style = "float: right" mat-button (click)="downloadFile(documento)">
                  <mat-icon>download</mat-icon>
                  Scarica
                </button>
                <button style = "float: right"  mat-button color="warn" (click)="deleteFile(documento)">
                  <mat-icon>delete</mat-icon>
                  Elimina
                </button>
              </div>
            </div>


            <hr style = "margin: 0px; padding: 0px">
          </ng-container>

        </mat-list>


        <!-- Add more settings as needed
        <button mat-icon-button (click) = "this.addFileConfiguration()"><mat-icon>add</mat-icon></button>

        -->
      </form>
    </mat-card-content>

    <mat-card-actions style="text-align: center;">
      <button mat-raised-button color="primary" (click)="this.updateSettings()">Salva configurazione</button>
    </mat-card-actions>
  </mat-card>
</div>
